<template>
  <div class="activity-main-root">
    <div class="custom-nav-block" :style="`padding-top:${barHeight}px`">
      <van-nav-bar class="van-bar" left-arrow @click-left="closeWeb" @click-right="handleToRule">
        <template #left>
          <img class="left-nav" src="@/assets/packageAssets/common/arrow02.png" alt="" />
        </template>
        <template #right>
          <img class="right-nav" src="@/assets/packageAssets/common/rules02.png" alt="" />
        </template>
      </van-nav-bar>
    </div>

    <div class="activity-con" :style="{ 'margin-top': `-${barHeight + 46}px` }">
      <div class="activity-head" :style="{ 'padding-top': `${barHeight + 46 + 5}px` }">
        <div class="head-title">
          <MyPLabel
            class="head-title-txt"
            :str="$t('lang.activityA1.k001')"
            :numsOption="[{ value: '500,000' || '', class: 'act-valentine-num' }]"
            :customClass="{ bean: 'act-valentine-bean' }"
          />
        </div>

        <div class="deal-tip">{{ $t('lang.activityA1.k002') }}</div>
        <div class="deal-line">
          <div class="timer">
            <img src="./images/clock.png" />
            <span class="time-num">
              <span>{{ countdownResult.days }}</span>
              <i>{{ $t('lang.commonM.k297') }}</i>
            </span>
            <span class="stp">:</span>
            <span class="time-num">
              <span>{{ countdownResult.hours }}</span>
              <i>{{ $t('lang.commonM.k364') }}</i>
            </span>
            <span class="stp">:</span>
            <span class="time-num">
              <span>{{ countdownResult.minutes }}</span>
              <i>{{ $t('lang.commonM.k365') }}</i>
            </span>
            <span class="stp">:</span>
            <span class="time-num">
              <span>{{ countdownResult.seconds }}</span>
              <i>{{ $t('lang.commonM.k366') }}</i>
            </span>
          </div>
        </div>

        <div class="head-empty"></div>
      </div>

      <div class="main-con">
        <div class="part-block" style="margin-top: 0">
          <div class="part-head">
            <span>{{ $t('lang.commonM.k208') }}</span>
          </div>
          <div class="part-tips">{{ $t('lang.commonM.k419') }}</div>

          <div v-if="actInfo" class="points-rank">
            <div class="pr-item">
              <div>{{ $t('lang.commonM.k221') }}</div>
              <div v-if="actInfo">{{ actInfo.score || 0 }}</div>
              <img class="size1" src="./images/heart.png" />
            </div>
            <div class="pr-gap"></div>
            <div class="pr-item">
              <div>{{ $t('lang.commonM.k222') }}</div>
              <div v-if="actInfo">{{ actInfo.rank || '--' }}</div>
              <img class="size2" src="./images/rankbar.png" />
            </div>
          </div>
        </div>

        <div class="part-block">
          <div class="part-head">
            <span>{{ $t('lang.commonM.k218') }}</span>
          </div>
          <div class="part-tips">{{ $t('lang.commonM.k420') }}</div>
          <div class="activity-reward">
            <div class="activity-item">
              <div class="reward-num">No.1</div>
              <div class="reward-coins">
                {{ boardData.num1Reward }}
                <img class="coins-icon" :src="getMatchImg('beans')" />
              </div>
            </div>
            <div class="activity-item">
              <div class="reward-num">No.2</div>
              <div class="reward-coins">
                {{ boardData.num2Reward }}
                <img class="coins-icon" :src="getMatchImg('beans')" />
              </div>
            </div>
            <div class="activity-item">
              <div class="reward-num">No.3</div>
              <div class="reward-coins">
                {{ boardData.num3Reward }}
                <img class="coins-icon" :src="getMatchImg('beans')" />
              </div>
            </div>
            <div class="activity-item">
              <div class="reward-num">No.4-10</div>
              <div class="reward-coins">
                {{ boardData.num4Reward }}
                <img class="coins-icon" :src="getMatchImg('beans')" />
              </div>
            </div>
          </div>

          <div class="btn-block">
            <div class="activity-btn" @click="handleToRank">{{ $t('lang.commonM.k220') }}</div>
          </div>
        </div>

        <div class="part-block">
          <div class="part-head">
            <span>{{ $t('lang.commonM.k215') }}</span>
          </div>
          <div class="part-tips">{{ $t('lang.commonM.k421') }}</div>
          <div v-if="actInfo && actInfo.milestoneStates" class="part-percent">
            <div class="progress-box">
              <!-- 左 -->
              <div>
                <div class="box-top" :style="{ opacity: actInfo.milestoneStates[0].state === 2 ? 0.5 : 1 }">
                  <!-- prettier-ignore -->
                  <div>
                    +{{ actInfo.milestoneStates[0].beans }}<img :src="getMatchImg('beans')">
                  </div>
                </div>
                <img v-if="actInfo.milestoneStates[0].state === 2" class="box" src="./images/box-open.png" />
                <img v-if="actInfo.milestoneStates[0].state === 1" class="box sharking" src="./images/box.png" />
                <img v-if="actInfo.milestoneStates[0].state === 0" class="box" src="./images/box.png" />
              </div>
              <!-- 中 -->
              <div>
                <div class="box-top" :style="{ opacity: actInfo.milestoneStates[1].state === 2 ? 0.5 : 1 }">
                  <!-- prettier-ignore -->
                  <div>
                    +{{ actInfo.milestoneStates[1].beans }}<img :src="getMatchImg('beans')">
                  </div>
                </div>
                <img v-if="actInfo.milestoneStates[1].state === 2" class="box" src="./images/box-open.png" />
                <img v-if="actInfo.milestoneStates[1].state === 1" class="box sharking" src="./images/box.png" />
                <img v-if="actInfo.milestoneStates[1].state === 0" class="box" src="./images/box.png" />
              </div>
              <!-- 右 -->
              <div>
                <div class="box-top" :style="{ opacity: actInfo.milestoneStates[2].state === 2 ? 0.5 : 1 }">
                  <!-- prettier-ignore -->
                  <div>
                    +{{ actInfo.milestoneStates[2].beans }}<img :src="getMatchImg('beans')">
                  </div>
                </div>
                <img v-if="actInfo.milestoneStates[2].state === 2" class="box" src="./images/box-open.png" />
                <img v-if="actInfo.milestoneStates[2].state === 1" class="box sharking" src="./images/box.png" />
                <img v-if="actInfo.milestoneStates[2].state === 0" class="box" src="./images/box.png" />
              </div>
            </div>
            <div class="progress-wraper">
              <div class="progress-bar">
                <div class="step step0" :class="{ on: actInfo.milestoneStates[0].state > 0 }"></div>
                <div class="step step1" :class="{ on: actInfo.milestoneStates[1].state > 0 }"></div>
                <div class="step step5" :class="{ on: actInfo.milestoneStates[2].state > 0 }"></div>
                <div class="progress-trace" :style="{ width: mePosition1 }">
                  <div v-if="mePosition1 !== '100%'" class="me"></div>
                </div>
              </div>
            </div>
            <div class="progress-points">
              <div class="points-name">{{ $t('lang.valRuFe.points') }}:</div>
              <div class="points-num">
                <div>{{ actInfo.milestoneStates[0].points }}</div>
                <div>{{ actInfo.milestoneStates[1].points }}</div>
                <div>{{ actInfo.milestoneStates[2].points }}</div>
              </div>
            </div>
            <div style="width: 100%; height: 20px"></div>
            <div class="progress-box">
              <!-- 左 -->
              <div>
                <div class="box-top" :style="{ opacity: actInfo.milestoneStates[3].state === 2 ? 0.5 : 1 }">
                  <!-- prettier-ignore -->
                  <div>
                    +{{ actInfo.milestoneStates[3].beans }}<img :src="getMatchImg('beans')">
                  </div>
                </div>
                <img v-if="actInfo.milestoneStates[3].state === 2" class="box" src="./images/box-open.png" />
                <img v-if="actInfo.milestoneStates[3].state === 1" class="box sharking" src="./images/box.png" />
                <img v-if="actInfo.milestoneStates[3].state === 0" class="box" src="./images/box.png" />
              </div>
              <!-- 中 -->
              <div>
                <div class="box-top" :style="{ opacity: actInfo.milestoneStates[4].state === 2 ? 0.5 : 1 }">
                  <!-- prettier-ignore -->
                  <div>
                    +{{ actInfo.milestoneStates[4].beans }}<img :src="getMatchImg('beans')">
                  </div>
                </div>
                <img v-if="actInfo.milestoneStates[4].state === 2" class="box" src="./images/box-open.png" />
                <img v-if="actInfo.milestoneStates[4].state === 1" class="box sharking" src="./images/box.png" />
                <img v-if="actInfo.milestoneStates[4].state === 0" class="box" src="./images/box.png" />
              </div>
              <!-- 右 -->
              <div>
                <div class="box-top" :style="{ opacity: actInfo.milestoneStates[5].state === 2 ? 0.5 : 1 }">
                  <!-- prettier-ignore -->
                  <div>
                    +{{ actInfo.milestoneStates[5].beans }}<img :src="getMatchImg('beans')">
                  </div>
                </div>
                <img v-if="actInfo.milestoneStates[5].state === 2" class="box" src="./images/box-open.png" />
                <img v-if="actInfo.milestoneStates[5].state === 1" class="box sharking" src="./images/box.png" />
                <img v-if="actInfo.milestoneStates[5].state === 0" class="box" src="./images/box.png" />
              </div>
            </div>
            <div class="progress-wraper">
              <div class="progress-bar">
                <div class="step step0" :class="{ on: actInfo.milestoneStates[3].state > 0 }"></div>
                <div class="step step1" :class="{ on: actInfo.milestoneStates[4].state > 0 }"></div>
                <div class="step step5" :class="{ on: actInfo.milestoneStates[5].state > 0 }"></div>
                <div class="progress-trace" :style="{ width: mePosition2 }">
                  <div v-if="mePosition2 !== '0%'" class="me"></div>
                </div>
              </div>
            </div>
            <div class="progress-points">
              <div class="points-name"></div>
              <div class="points-num">
                <div>{{ actInfo.milestoneStates[3].points }}</div>
                <div>{{ actInfo.milestoneStates[4].points }}</div>
                <div>{{ actInfo.milestoneStates[5].points }}</div>
              </div>
            </div>
          </div>

          <div class="btn-block">
            <div v-if="canClaim == 'canClaim'" class="activity-btn" @click="handleClaim()">{{ $t('lang.commonM.k073') }}</div>
            <div v-if="canClaim == 'canNotClaim'" class="activity-btn btn-disable">{{ $t('lang.commonM.k073') }}</div>
            <div v-if="canClaim == 'claimed'" class="activity-btn btn-disable">{{ $t('lang.commonM.k074') }}</div>
          </div>
        </div>
      </div>
    </div>

    <div v-if="showReward" class="mask">
      <div class="dia-con">
        <div class="reward-item">
          <span>{{ reward }}</span>
          <img :src="getMatchImg('beans')" alt="" />
        </div>

        <p class="dia-tips">{{ $t('lang.commonM.k378') }}</p>

        <div class="rules-btn" @click="showReward = false">{{ $t('lang.ok') }}</div>
      </div>
    </div>
  </div>
</template>

<script>
import { normalActBaseInfo, normalMilesClaim } from './apidir/api.js'

import countDown from '@/mixin/count-down.js'

export default {
  mixins: [countDown],
  data() {
    return {
      actInfo: null,
      packageName: '',
      boardData: {
        num1Reward: 0,
        num2Reward: 0,
        num3Reward: 0,
        num4Reward: 0
      },
      canClaim: 'canNotClaim',
      mePosition1: '7%',
      mePosition2: '0%',
      showReward: false,
      reward: 0,
      loading: false
    }
  },
  methods: {
    handleToRule() {
      this.$router.push({ path: '/valentine-rules-female', query: { from: 'valentine-main-female' } })
    },
    handleToRank() {
      this.$router.push({ path: '/valentine-rank-female', query: { from: 'valentine-main-female' } })
    },
    handleReplaceToRank() {
      this.$router.replace({ path: '/valentine-rank-female' })
    },
    handleClaim() {
      if (this.actInfo.milestoneStates && this.actInfo.milestoneStates.length) {
        if (this.actInfo.milestoneStates.some((item) => item.state === 1)) {
          if (this.loading) {
            return
          }
          this.loading = true

          normalMilesClaim()
            .then((resData) => {
              if (resData && !resData.error) {
                this.showReward = true
                this.reward = resData.data
                this.fetchData()
              }
            })
            .finally(() => {
              this.loading = false
            })
        }
      }
    },
    fetchData() {
      normalActBaseInfo().then((resData) => {
        if (resData && !resData.error) {
          this.actInfo = resData || null

          if (!this.actInfo) return

          if (this.actInfo.countdown <= 0) {
            this.handleReplaceToRank()
            return
          }

          // 初始化倒计时
          if (this.actInfo.endTimestamp) {
            this.initCountDown(resData.endTimestamp, true, true)
          }

          if (this.actInfo.leaderboardRewards && this.actInfo.leaderboardRewards.length) {
            this.boardData.num1Reward = this.actInfo.leaderboardRewards[0] || 0
            this.boardData.num2Reward = this.actInfo.leaderboardRewards[1] || 0
            this.boardData.num3Reward = this.actInfo.leaderboardRewards[2] || 0
            this.boardData.num4Reward = this.actInfo.leaderboardRewards[3] || 0
          }

          if (this.actInfo.milestoneStates && this.actInfo.milestoneStates.length === 6) {
            // 可领取
            let claimStatus = 'canNotClaim'
            if (this.actInfo.milestoneStates.some((item) => item.state === 1)) {
              claimStatus = 'canClaim'
            }
            if (this.actInfo.milestoneStates.every((item) => item.state === 2)) {
              claimStatus = 'claimed'
            }
            this.canClaim = claimStatus

            if (this.actInfo.score < this.actInfo.milestoneStates[0].points) {
              this.mePosition1 = '7%'
              this.mePosition2 = '0%'
            }

            if (this.actInfo.score === this.actInfo.milestoneStates[0].points) {
              this.mePosition1 = '12.6%'
              this.mePosition2 = '0%'
            }

            if (this.actInfo.score > this.actInfo.milestoneStates[0].points && this.actInfo.score < this.actInfo.milestoneStates[1].points) {
              this.mePosition1 = '35%'
              this.mePosition2 = '0%'
            }

            if (this.actInfo.score === this.actInfo.milestoneStates[1].points) {
              this.mePosition1 = '55%'
              this.mePosition2 = '0%'
            }

            if (this.actInfo.score > this.actInfo.milestoneStates[1].points && this.actInfo.score < this.actInfo.milestoneStates[2].points) {
              this.mePosition1 = '75%'
              this.mePosition2 = '0%'
            }

            if (this.actInfo.score == this.actInfo.milestoneStates[2].points) {
              this.mePosition1 = '100%'
              this.mePosition2 = '0%'
            }

            if (this.actInfo.score >= this.actInfo.milestoneStates[2].points && this.actInfo.score < this.actInfo.milestoneStates[3].points) {
              this.mePosition1 = '100%'
              this.mePosition2 = '7%'
            }

            if (this.actInfo.score == this.actInfo.milestoneStates[3].points) {
              this.mePosition1 = '100%'
              this.mePosition2 = '12.6%'
            }

            if (this.actInfo.score > this.actInfo.milestoneStates[3].points && this.actInfo.score < this.actInfo.milestoneStates[4].points) {
              this.mePosition1 = '100%'
              this.mePosition2 = '35%'
            }

            if (this.actInfo.score == this.actInfo.milestoneStates[4].points) {
              this.mePosition1 = '100%'
              this.mePosition2 = '55%'
            }

            if (this.actInfo.score > this.actInfo.milestoneStates[4].points && this.actInfo.score < this.actInfo.milestoneStates[5].points) {
              this.mePosition1 = '100%'
              this.mePosition2 = '75%'
            }

            if (this.actInfo.score >= this.actInfo.milestoneStates[5].points) {
              this.mePosition1 = '100%'
              this.mePosition2 = '100%'
            }
          }
        }
      })
    }
  },
  created() {
    this.fetchData()
  }
}
</script>

<style lang="less" scoped>
.activity-main-root {
  width: 100%;
  min-height: 100vh;
  background: #e14364;

  .custom-nav-block {
    background: url(./images/main-bg.png) top left / 100% auto no-repeat;
  }

  .activity-con {
    position: relative;
    .activity-head {
      width: 100%;
      min-height: 432px;
      font-size: 0;
      position: relative;
      background: url(./images/main-bg.png) top left / 100% auto no-repeat;
      .head-title {
        width: 100%;
        padding: 0 20px;
        margin: auto;

        .head-title-txt {
          color: #fff;
          text-align: center;
          text-shadow: 4px 3px 0 #ca2143, 2px 3px 0 #ca2143, 0 0 30px rgba(183, 17, 56, 0.65);
          font-family: 'Anton-Regular';
          font-size: 38px;
          font-style: normal;
          font-weight: bold;
          line-height: 120%;
        }
      }

      .deal-tip {
        width: 100%;
        margin-top: 60px;
        line-height: 28px;

        color: #fff;
        text-align: center;
        text-shadow: 2px 2px 0 #ca2143, 1px 2px 0 #ca2143, 0 0 10px rgba(183, 17, 56, 0.75);
        font-family: Antonio;
        font-size: 20px;
        font-weight: 400;
      }

      .deal-line {
        width: 100%;
        margin: 3px auto 0;
        display: flex;
        align-items: center;
        justify-content: center;

        .timer {
          min-width: 223px;
          height: 40px;
          padding: 0 24px;

          display: inline-flex;
          align-items: center;
          justify-content: center;

          border-radius: 40px;
          border: 1px solid rgba(255, 255, 255, 0.1);
          background: linear-gradient(90deg, rgba(255, 255, 255, 0.9) 0%, rgba(255, 236, 239, 0.9) 50%, rgba(255, 255, 255, 0.9) 100%);
          backdrop-filter: blur(2px);
          img {
            width: 32px;
            height: 32px;
            margin: 0 3px;
          }
          > span {
            color: #f13157;
            font-family: 'TikTokSans-Regular';
            font-size: 20px;
            font-style: normal;
            font-weight: bold;
            line-height: 22px;
            display: flex;
            align-items: flex-end;
            i {
              font-size: 16px;
              line-height: 18px;
            }
          }
          .stp {
            padding: 0 2px;
          }
          .time-num {
            span {
              width: 26px;
              text-align: center;
            }
          }
        }
      }

      .head-empty {
        height: 105px;
      }
    }

    .main-con {
      position: relative;
      overflow: hidden;
      padding-bottom: 79px;
      margin-top: -105px;

      .part-block {
        width: 355px;
        margin: 16px auto 0;
        padding-bottom: 24px;
        background: #fff5f9;
        border-radius: 12px;
        .part-head {
          width: 355px;
          line-height: 42px;
          background: #ff749b;
          border-radius: 12px 12px 0px 0px;
          text-align: center;
          span {
            color: #fff;
            font-family: 'TikTokSans-Regular';
            font-size: 17px;
            font-weight: bold;
          }
        }
        .part-tips {
          width: 100%;
          padding: 16px;
          font-family: TikTokSans-Regular;
          font-size: 15px;
          color: #dd173f;
          line-height: 22px;
          font-weight: normal;
        }

        .points-rank {
          display: flex;
          align-items: center;
          justify-content: center;
          padding: 0 16px;
          .pr-item {
            flex: 1;
            min-height: 66px;
            padding: 10px;
            background: #ffd9e0;
            border-radius: 8px;
            display: flex;
            flex-direction: column;
            align-items: flex-start;
            justify-content: center;
            position: relative;
            div:nth-child(1) {
              font-family: TikTokSans-Regular;
              font-weight: 400;
              font-size: 15px;
              color: #dd173f;
              line-height: 20px;
            }
            div:nth-child(2) {
              font-family: TikTokSans-Regular;
              font-weight: bold;
              font-size: 20px;
              color: #dd173f;
              line-height: 24px;
              max-width: calc(100% - 34px);
              word-wrap: break-word;
            }
            img {
              position: absolute;
              right: 5px;
              bottom: 0px;
            }
            img.size1 {
              width: 28px;
              height: 28px;
              bottom: 5px;
            }
            img.size2 {
              width: 40px;
              height: 40px;
            }
          }
          .pr-gap {
            width: 40px;
          }
        }

        .activity-reward {
          width: 100%;
          padding: 0 16px;
          min-height: 116px;
          margin: 0 auto;

          .activity-item {
            font-family: TikTokSans-Regular;
            font-weight: 400;
            font-size: 15px;
            color: #dd173f;
            line-height: 20px;
            display: flex;
            justify-content: space-between;
            margin-bottom: 12px;
            .reward-coins {
              display: flex;
              align-items: center;
              font-weight: bold;
              color: #dd173f;
              .coins-icon {
                width: 16px;
                height: 16px;
                margin: 0 3px;
              }
            }
          }
        }
        .part-percent {
          width: 100%;
          padding: 0 16px 0;
          .progress-box {
            width: 300px;
            margin: 0 auto;
            display: flex;
            align-items: center;
            > div {
              display: flex;
              flex-direction: column;
              .box-top {
                min-width: 52px;
                min-height: 31px;
                padding: 0 5px;
                display: flex;
                flex-direction: column;
                align-items: center;
                justify-content: center;
                background: url(./images/tip-wrap.png) left top / 100% 100% no-repeat;
                > div {
                  color: #fff;
                  font-family: 'TikTokSans-Regular';
                  font-size: 15px;
                  font-style: normal;
                  font-weight: 700;
                  line-height: 20px;
                  padding-bottom: 5px;
                }
                img {
                  width: 14px;
                  margin: 0 2px;
                }
              }
              .box {
                width: 34px;
              }
              .sharking {
                // animation: shake 1.5s infinite linear;
                // transform-origin: center bottom;
              }
              &:nth-child(1) {
                display: flex;
                align-items: center;
                justify-content: center;
                transform: translateX(20px);
              }
              &:nth-child(2) {
                flex: 1;
                display: flex;
                align-items: center;
                justify-content: center;
                transform: translateX(15px);
              }
              &:nth-child(3) {
                display: flex;
                align-items: center;
                justify-content: flex-end;
                transform: translateX(15px);
              }
            }
          }
          .progress-wraper {
            width: 286px;
            height: 20px;
            margin: 5px auto 0;
            display: flex;
            align-items: center;
            .progress-bar {
              width: 100%;
              height: 8px;
              border-radius: 100px;
              background: #fff1c2;
              display: flex;
              align-items: center;
              justify-content: flex-start;
              position: relative;
              overflow: visible;

              .step {
                width: 14px;
                height: 14px;
                border-radius: 12px;
                border-radius: 12px;
                border: 2px solid #fff;
                background: #fff1c2;
                position: absolute;
                top: 50%;
                margin-top: -7px;
                z-index: 9;
                &.on {
                  border: 2px solid #fff;
                  background: #ff4906;
                }
              }
              .step0 {
                left: 36px;
              }
              .step1 {
                left: calc(50% + 18px);
                margin-left: -7px;
              }
              .step5 {
                left: 100%;
                margin-left: -7px;
              }

              .progress-trace {
                width: 20px;
                height: 100%;
                border-radius: 100px;
                background: linear-gradient(90deg, #ffd280 0%, #f62b40 73.57%), #ff4906;
                position: relative;
                overflow: visible;
                .me {
                  position: absolute;
                  top: 50%;
                  right: -16px;
                  z-index: 99;
                  margin-top: -10px;
                  width: 31px;
                  height: 20px;
                  background: url(./images/progress-me.png) left top / 100% 100% no-repeat;
                }
              }
            }
          }
          .progress-points {
            width: 100%;
            height: 20px;
            margin: 0 auto;
            display: flex;
            align-items: center;

            .points-name {
              width: 50px;
              color: #af2f3a;
              font-family: 'TikTokSans-Regular';
              font-size: 12px;
              font-style: normal;
              font-weight: 600;
              line-height: normal;
            }
            .points-num {
              flex: 1;
              color: #af2f3a;
              font-family: 'TikTokSans-Regular';
              font-size: 12px;
              font-style: normal;
              font-weight: 600;
              line-height: normal;

              display: flex;
              align-items: center;
              justify-content: space-between;
              > div {
                &:nth-child(1) {
                  transform: translateX(5px);
                }
                &:nth-child(2) {
                  transform: translateX(-6px);
                }
                &:nth-child(3) {
                  transform: translateX(-11px);
                }
              }
            }
          }
        }
      }
      .task-block {
        padding: 0 16px;
        .part-tips-b {
          font-family: TikTokSans-Regular;
          font-weight: 500;
          font-size: 17px;
          color: #ffffff;
          line-height: 22px;
          margin-top: 32px;
          text-align: left;
        }
        .part-task {
          margin-top: 13px;
          font-family: TikTokSans-Regular;
          font-weight: 400;
          font-size: 15px;
          color: #ffffff;
          line-height: 20px;
          display: flex;
          justify-content: space-between;
        }
      }

      .btn-block {
        display: block;
        width: 100%;
        margin: 30px auto 8px;
        text-align: center;
        .activity-btn {
          min-width: 275px;
          display: inline-block;
          padding: 10px 15px;
          border-radius: 30px;
          background: linear-gradient(93deg, #ff749b 5.83%, #ff4d7b 95.33%);
          font-family: TikTokSans-Regular;
          font-weight: 500;
          font-size: 20px;
          color: #ffffff;
          line-height: 26px;
          text-align: center;
          &.btn-disable {
            opacity: 0.4;
          }
        }
      }
    }
  }

  .mask {
    position: fixed;
    top: 0;
    left: 0;
    z-index: 999;
    width: 100vw;
    height: 100vh;
    background: rgba(0, 0, 0, 0.7);
    overflow-y: auto;

    display: flex;
    align-items: center;
    justify-content: center;

    .dia-con {
      width: 315px;
      padding: 30px 16px;
      background: #fdfdfd;
      border-radius: 12px;

      .reward-item {
        margin-top: 24px;
        padding-bottom: 6px;
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: center;

        img {
          width: 20px;
          margin: 0 4px;
        }

        span {
          font-family: RobotoFlex-Regular;
          font-weight: bold;
          font-size: 20px;
          color: #333333;
          line-height: 28px;
          text-align: center;
        }
      }

      .dia-tips {
        width: 100%;
        font-family: RobotoFlex-Regular;
        font-size: 17px;
        color: #333333;
        line-height: 18px;
        text-align: center;
        margin-bottom: 16px;
      }

      .rules-btn {
        width: 255px;
        line-height: 26px;
        margin: 0 auto;
        padding: 10px 15px;
        border-radius: 30px;
        background: linear-gradient(93deg, #ff749b 5.83%, #ff4d7b 95.33%);
        font-family: TikTokSans-Regular;
        font-weight: 500;
        font-size: 20px;
        color: #ffffff;
        text-align: center;
      }
    }
  }
}

@keyframes shake {
  0% {
    transform: rotate(0deg);
  }
  25% {
    transform: rotate(-10deg);
  }
  50% {
    transform: rotate(0deg);
  }
  75% {
    transform: rotate(10deg);
  }
  100% {
    transform: rotate(0deg);
  }
}

html[lang='ar'],
html[lang='fa'],
html[lang='he'] {
  .activity-main-root .activity-con .main-con .part-block .points-rank .pr-item img {
    right: unset;
    left: 5px;
  }

  .activity-main-root {
    .activity-con {
      .main-con {
        .part-block {
          .part-percent {
            .progress-box {
              > div {
                &:nth-child(1) {
                  display: flex;
                  align-items: center;
                  justify-content: center;
                  transform: translateX(-20px);
                }
                &:nth-child(2) {
                  flex: 1;
                  display: flex;
                  align-items: center;
                  justify-content: center;
                  transform: translateX(-15px);
                }
                &:nth-child(3) {
                  display: flex;
                  align-items: center;
                  justify-content: flex-end;
                  transform: translateX(-15px);
                }
              }
            }
            .progress-wraper {
              .progress-bar {
                .step0 {
                  left: unset;
                  right: 36px;
                }
                .step1 {
                  left: unset;
                  right: calc(50% + 18px);
                  margin-right: -7px;
                }
                .step5 {
                  left: unset;
                  right: 100%;
                  margin-right: -7px;
                }

                .progress-trace {
                  .me {
                    right: unset;
                    left: -16px;
                    transform: rotateY(180deg);
                  }
                }
              }
            }
            .progress-points {
              .points-num {
                > div {
                  &:nth-child(1) {
                    transform: translateX(-5px);
                  }
                  &:nth-child(2) {
                    transform: translateX(6px);
                  }
                  &:nth-child(3) {
                    transform: translateX(11px);
                  }
                }
              }
            }
          }
        }
      }
    }
  }
}
</style>

<style>
/* .act-valentine-num {
  font-size: 46px;
  line-height: 120%;
} */
.act-valentine-bean {
  width: 40px;
  height: 40px;
}
</style>
